import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const RoomsListPage = lazy(() => import('./RoomsListPage'));

export const roomRoutes: RouteObject[] = [
  {
    path: 'rooms',
    element: (
      <ProtectedRoute action="rooms:view">
        <RoomsListPage />
      </ProtectedRoute>
    ),
  },
];
